export default __webpack_public_path__ + "static/media/visa.a832f682.svg";